const path = "competitors";

export const FETCH_COMPETITORS_REQUEST = `${path}/FETCH_COMPETITORS_REQUEST`;
export const FETCH_COMPETITORS_SUCCESS = `${path}/FETCH_COMPETITORS_SUCCESS`;
export const FETCH_COMPETITORS_FAILURE = `${path}/FETCH_COMPETITORS_FAILURE`;
export const FETCH_COMPETITORS_CANCEL = `${path}/FETCH_COMPETITORS_CANCEL`;
export const CLEAR_COMPETITORS = `${path}/CLEAR_COMPETITORS`;
